<template>
    <v-dialog v-model="model" max-width="600px" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
        <v-card>
            <div class="pl-4 pr-3 py-3 primary">
                <div class="d-flex align-center justify-space-between">
                    <div>
                        <v-layout align-center>
                            <v-icon size="12px" color="white" class="mr-2">fas fa-user fa-fw</v-icon> 
                            <div class="white--text font-weight-medium caption">EDIT NAME</div> 
                        </v-layout>
                    </div>
                    <div>
                        <v-btn small text fab @click="$emit('cancel')" class="my-0">
                            <v-icon small color="white">fa-times</v-icon> 
                        </v-btn>
                    </div>
                </div>
            </div>

            <v-card-text class="pt-8">
                <div class="px-4 black--text body-1 text-center">
                    <v-text-field
                        v-model="info.name"
                        label="Nombre"
                        outlined dense
                        maxlength="40"
                        @keydown.enter="validate"
                        :disabled="sending">
                        <template v-slot:prepend>
                            <v-icon color="info" class="mt-1 mr-1" small>fa-user fa-fw</v-icon>
                        </template>
                    </v-text-field>
                </div>
            </v-card-text>

            <div class="d-flex justify-end align-center px-4 pb-4" :class="(sending) ? 'pa-1' : 'pa-4'">
                <v-btn text large class="info--text text--darken-1" @click="$emit('cancel')" v-if="!sending">Cancel</v-btn>
                <v-btn text large class="accent" @click="validate" v-if="!sending">Save</v-btn>
                <SendingLoader v-if="sending" />
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import Personal from '@/firebase/personal'

export default {
    data: () => ({
        sending: false,
        info: {
            name: ''
        }
    }),
    props: ['model'],
    watch: {
        model(val) {
            if (val == false) {
                this.sending = false;
            }
            this.init();
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.info.name = JSON.parse(JSON.stringify(this.user.name));
        },
        validate() {
            if (!this.validateIsEmpty(this.info.name)) {
                this.save();
            }
        },
        save() {
            this.sending = true;

            Personal.updateName(this.user.uid, this.info.name)
                    .then(response => {
                        if (response === true) {
                            this.$emit('changed');
                            this.$store.dispatch('setSnack', {kind:'success', text:'Name updated.'});
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'Error!.'});
                        }
                        this.sending = false;
                    });
        }
    }
}
</script>

